import { Component, OnInit, Input } from '@angular/core';
import { MdbSelectOption } from '../common-types';
import { MultipleSelectOption, OptionValueSelector } from '../multiple-select-control/multiple-select-control';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'multiple-choice-control',
  templateUrl: './multiple-choice-control.component.html',
  styleUrls: ['./multiple-choice-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MultipleChoiceControlComponent,
    multi: true
  }]
})
export class MultipleChoiceControlComponent extends BaseControl {

  @Input() options: MultipleSelectOption[] = [];
  @Input() isInline: boolean = false;
  @Input() columns: number = 3;
  @Input() valueSelector: OptionValueSelector = OptionValueSelector.Id;

  constructor() {
    super();
  }

  ngOnInit() {
    
  }

  selectOption(option: MultipleSelectOption) {
    switch (this.valueSelector) {
      case OptionValueSelector.Id:
        this.value = option.id;
        break;

      case OptionValueSelector.Index:
        this.value = this.options.indexOf(option).toString();
        break;

      case OptionValueSelector.Value:
        this.value = option.value;
        break;
    }

    this.updateValue();
  }

  onWriteValue(value) {
    if (value && value != ' ') {
      switch (this.valueSelector) {

        case OptionValueSelector.Id:
          this.options.forEach(option => {
            if (option.id == value) {
              option.selected = true;
            }
          });

          break;
  
        case OptionValueSelector.Index:
          if (this.options[value]) this.options[value].selected = true;
          break;
  
        case OptionValueSelector.Value:
          this.options.forEach(option => {
            if (option.value == value) {
              option.selected = true;
            }
          });

          break;

      }      
    }
  }

}
